import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import { HashRouter as Router } from 'react-router-dom';

import AppComponent from './components/App';
import { CONFIGURATIONS_PATH } from './constants/paths/internal';
import configureStore from './store';

const store = configureStore();

function renderApp(App: typeof AppComponent) {
  if (window.location.search.includes('fromConfigurator=true')) {
    handleConfiguratorRedirect();
  }

  const ConnectedApp = (
    <Provider store={store}>
      <Router>
        <App />
      </Router>
    </Provider>
  );

  render(ConnectedApp, document.getElementById('root'));
}

renderApp(AppComponent);

if (module.hot) {
  module.hot.accept('./components/App', () => {
    const NextApp = require('./components/App').default;
    renderApp(NextApp);
  });
}

function handleConfiguratorRedirect() {
  const hash = window.location.hash === '' ? `#${CONFIGURATIONS_PATH}` : window.location.hash;

  const pathname =
    window.location.pathname.slice(-1) === '/'
      ? window.location.pathname
      : `${window.location.pathname}/`;

  window.history.replaceState({}, document.title, window.location.origin + pathname + hash);
}
